module.exports = __webpack_public_path__ + "static/img/bg_fr.ff91568.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bts-2026-sale/bg_fr.png
// module id = G7eW
// module chunks = 2